module.exports = __webpack_public_path__ + "static/media/poktlogo.2f500dab.png";